import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import { Redirect, Route } from "react-router-dom";

// Common pages
import Home from "../pages/Home";
import RoomSwap from "../pages/RoomSwap";
import Uploads from "../pages/Uploads";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface RoutesProps { }
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface RoutesState { }

const Routes: React.FC<RoutesProps> = () => {
  return (
    <IonReactRouter basename={"/"}>
      <IonRouterOutlet id="main-content" animated={false}>
        <Route path={"/home"} exact>
          <Home />
        </Route>
        <Route path={"/room"} exact>
          <RoomSwap />
        </Route>
        <Route path={"/uploads"} exact>
          <Uploads />
        </Route>
        <Route path={"/"} exact>
          <Redirect to="/home" exact />
        </Route>
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

export default Routes;
